import { render, staticRenderFns } from "./RegistrarPostulante.vue?vue&type=template&id=613f5345&scoped=true&"
import script from "./RegistrarPostulante.vue?vue&type=script&lang=js&"
export * from "./RegistrarPostulante.vue?vue&type=script&lang=js&"
import style0 from "./RegistrarPostulante.vue?vue&type=style&index=0&id=613f5345&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613f5345",
  null
  
)

export default component.exports